import { ref, computed, reactive } from 'vue'
import { camelizeKeys } from 'humps'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import { useRequestReject } from './useRequestReject'
import { useYearSelector } from '@/services/useYearSelector'
import { useDialog } from '@/services/useDialog'
import { useMemoryItems } from './useMemoryItems'
import { useCurrentUser } from '@/services/useCurrentUser'
import axios from '@/axios'

const activitiesState = reactive({
  activities: [],
})
const usersState = reactive({
  users: [],
})

// hot fix; TODO refactoring
const actionTypes = [
  { id: 1, name: '調査研究' },
  { id: 2, name: '研修' },
  { id: 3, name: '要望·陳情' },
]

const initialSelectedActionTypes = () => {
  return [
    { id: 1, name: '調査研究', hasAttribute: false },
    { id: 2, name: '研修', hasAttribute: false },
    { id: 3, name: '要望·陳情', hasAttribute: false },
  ]
}

let currentPoliticalAction = reactive({
  id: null,
  user: {
    uname: '',
  },
  actionTypes: null,
  selectedActionTypes: initialSelectedActionTypes(),
  submissionDate: undefined,
  startDate: '',
  endDate: '',
  place: '',
  memberName: '',
  purpose: '',
  updateDate: '',
  updatedAt: '',
  application: {
    id: null,
    submissionDate: '',
    remarks: '',
    sentBackItems: [],
    images: [],
    user: {
      uname: '',
    },
    option: {
      viewType: 0,
      isMine: true,
    },
  },
  report: {
    id: null,
    submissionDate: '',
    overview: '',
    remarks: '',
    sentBackItems: [],
    user: null,
    images: [],
    option: {
      viewType: 0,
      isMine: true,
    },
  },
  memory: {
    id: null,
    sentBackItems: [],
    expenses: [],
    user: null,
    currentExpenses: {
      type: null,
      from: '',
      to: '',
      isRoundTrip: false,
      people: null,
      distance: null,
      stayDays: null,
      amount: null,
      detail: null,
      receipt: {
        id: null,
        expenseTypeId: null,
        expenseAmount: null,
        isDistributed: null,
        numerator: null,
        denominator: null,
        expenseDate: '',
        expenseContent1: '',
        expense_content2: '',
        images: [],
      },
      item: null,
    },
    option: {
      viewType: 0,
      isMine: true,
    },
  },
})

const filteredStatus = ref([])
const isReversedSort = ref(false)

export const usePoliticalActions = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const { rejectedAttrs } = useRequestReject()
  const { currentUser } = useCurrentUser()

  const resetCurrentPoliticalAction = () => {
    currentPoliticalAction = {
      id: null,
      user: {
        uname: '',
      },
      actionTypes: null,
      selectedActionTypes: initialSelectedActionTypes(),
      submissionDate: null,
      startDate: '',
      endDate: '',
      place: '',
      memberName: '',
      purpose: '',
      updateDate: '',
      updatedAt: '',
      application: {
        id: null,
        submissionDate: '',
        remarks: '',
        sentBackItems: [],
        images: [],
        additionalResources: [],
        user: {
          uname: '',
        },
        option: {
          viewType: 0,
          isMine: true,
        },
      },
      report: {
        id: null,
        submissionDate: '',
        overview: '',
        remarks: '',
        sentBackItems: [],
        user: null,
        images: [],
        option: {
          viewType: 0,
          isMine: true,
        },
      },
      memory: {
        id: null,
        sentBackItems: [],
        expenses: [],
        user: null,
        currentExpenses: {
          type: null,
          from: '',
          to: '',
          isRoundTrip: false,
          people: null,
          distance: null,
          stayDays: null,
          amount: null,
          detail: null,
          receipt: {
            id: null,
            expenseTypeId: null,
            expenseAmount: null,
            isDistributed: null,
            numerator: null,
            denominator: null,
            expenseDate: '',
            expenseContent1: '',
            expense_content2: '',
            images: [],
          },
          item: null,
        },
        option: {
          viewType: 0,
          isMine: true,
        },
      },
    }
  }

  const setCurrentPoliticalAction = async activityId => {
    const { memoryItemTypes } = useMemoryItems()
    const res = await getActivity(activityId)

    if (res) {
      currentPoliticalAction = { ...res }
      if (currentPoliticalAction.actionTypes != null) {
        currentPoliticalAction.selectedActionTypes = actionTypesToArray(
          currentPoliticalAction.actionTypes,
        )
      } else {
        currentPoliticalAction.selectedActionTypes = initialSelectedActionTypes()
      }
      if (currentPoliticalAction.memory.expenses.length > 0) {
        for (
          let i = 0;
          i < currentPoliticalAction.memory.expenses.length;
          i++
        ) {
          const memoryItemType = memoryItemTypes.find(memoryItemType => {
            return (
              memoryItemType.id ===
              currentPoliticalAction.memory.expenses[i].type
            )
          })
          currentPoliticalAction.memory.expenses[i].type = [memoryItemType]
        }
      }
      return new Promise(resolve => resolve(true))
    }
  }

  /**
   * 政務活動リストを取得する
   *
   * @param {number} year 取得する年度
   */
  const getActivities = async (year = new Date().getFullYear()) => {
    try {
      toggleShowLoader(true)
      let res = await axios.get(`/actions?year=${year}`)
      res = camelizeKeys(res)
      activitiesState.activities = Array.from(res.data.actions)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  /**
   * 政務活動を取得する
   *
   * @param {number} activityId political_actions.id
   * @returns object
   */
  const getActivity = async activityId => {
    try {
      let res = null
      toggleShowLoader(true)
      res = await axios.get(`/actions/${activityId}`)
      res = camelizeKeys(res.data.action)
      if (res.application.submissionDate) {
        res.submissionDate = res.application.submissionDate
      }
      if (res.memory) {
        if (res.memory.expenses.length > 0) {
          for (let i = 0; i < res.memory.expenses.length; i++) {
            res.memory.expenses[i].id = i
          }
        }
      }

      toggleShowLoader(false)
      return res
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  /**
   * 政務活動を削除する
   *
   * @param {number} activityId political_actions.id
   */
  const deleteActivity = async activityId => {
    try {
      toggleShowLoader(true)
      const res = await axios.delete(`/actions/${activityId}`)
      await getActivitiesAfterResponse(res)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  /**
   * 政務活動をダウンロードする
   *
   * @param {number} activityId political_actions.id
   */
  const downloadActivity = async activityId => {
    await axios
      .get(`/download/actions/${activityId}`, { responseType: 'blob' })
      .then(response => {
        const content_type = response.headers['content-type']
        const blob = new Blob([response.data], { type: content_type })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        //ファイル名をレスポンスヘッダから取得したい
        let filename = '政務活動.zip'
        const disposition = response.headers['content-disposition'].toString()
        if (disposition != null) {
          let findex = disposition.indexOf('filename*=')
          //ファイル名
          if (findex != -1) {
            filename = disposition.substring(findex + 10)
            try {
              filename = decodeURI(
                filename.substring(filename.indexOf("''") + 2),
              )
            } catch (e) {
              filename = '政務活動_.zip'
            }
          } else {
            findex = disposition.indexOf('filename=')
            if (findex != -1) {
              filename = disposition.substring(findex + 9)
            }
          }
        }

        link.download = filename
        link.href = url
        link.click()
      })
  }

  /**
   * レストポンスが正常な場合政務活動リストを取得する
   *
   * @param {object} response
   * @returns void
   */
  const getActivitiesAfterResponse = async response => {
    if (response?.data?.code !== 0) {
      return
    }
    const { closeDialog } = useDialog()
    const { currentYear } = useYearSelector()
    await getActivities(currentYear.value)
    closeDialog()
  }

  const actionTypesToArray = actionTypesNumber => {
    let bin = Number(actionTypesNumber[0].type).toString(2) //Number.toString(2)は、数値の２進数に変換した文字列
    // ２進数の文字列を反転させる
    const splitString = bin.split('')
    const reverseArray = splitString.reverse()
    bin = reverseArray.join('')
    let res = []
    for (let i = 0; i < actionTypes.length; i++) {
      let aType = {
        id: i + 1,
        name: actionTypes[i].name,
        hasAttribute: false,
      }
      // 反転させた２進数の文字列が１の時trueとする
      if (bin.length > i && bin[i] == '1') {
        aType.hasAttribute = true
      } else {
        aType.hasAttribute = false
      }
      res.push(aType)
    }
    return res
  }

  const rejectRequest = () => {
    currentPoliticalAction.sentBack = JSON.parse(JSON.stringify(rejectedAttrs))
  }

  const approveRequest = () => {
    console.log('approve')
  }

  const canOpenActivitiesDialog = status => {
    const isStatusNull = status === null
    const isAuthorizer = currentUser.role.is_authorizer === 1

    if (isStatusNull && isAuthorizer) return false
    return true
  }

  const canOpenTab = (status, viewType) => {
    // 管理者かつ未作成のタブをクリックした場合
    const isAuthorizer = currentUser.role.is_authorizer === 1
    const isStatusNull = status === null || status === 0
    if (isAuthorizer && isStatusNull) return false

    // 申請書が作成されていない場合
    const isApplicationNull = viewType === null || viewType === 0
    if (isApplicationNull) return false

    return true
  }

  const actionTypeNames = selectedTypes => {
    let joinedName = ''
    console.log(selectedTypes, 'actionTypeNamesの引数：selectedTypes')
    for (let i = 0; i < selectedTypes.length; i++) {
      if (selectedTypes[i].hasAttribute == true) {
        joinedName = joinedName + selectedTypes[i].name + ' / '
      }
    }
    return joinedName
  }

  // ユーザーリストの取得
  const getUsers = async () => {
    try {
      toggleShowLoader(true)
      let res = null
      res = await axios.get(`/users/list`)
      let userList = []
      let Congressman = []
      res.data.users.forEach(user => {
        if (user.role_id === 1) {
          Congressman.push(user)
        }
      })
      for (let i = 0; i < Congressman.length; i++) {
        userList[i] = { id: `${i + 1}`, name: Congressman[i].name }
      }
      usersState.users = userList
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    activities: computed(() => activitiesState.activities),
    getActivities,
    getUsers,
    users: computed(() => usersState.users),
    deleteActivity,
    downloadActivity,
    setCurrentPoliticalAction,
    resetCurrentPoliticalAction,
    rejectRequest,
    approveRequest,
    getActivitiesAfterResponse,
    canOpenActivitiesDialog,
    canOpenTab,
    actionTypeNames,
    currentPoliticalAction,
    filteredStatus,
    isReversedSort,
  }
}
